module.exports = __webpack_public_path__ + "logo-ubisoft_plus.svg";